import { useEffect } from 'react';
import _ from 'lodash';

import IconButton from '@mui/material/IconButton';

import PropTypes from 'prop-types';

import { cmsService, eventService } from '../services/homii-services';

import FaqAccordion from '../components/faq/faq-accordion.component';
import FaqTabs from '../components/faq/faq-tabs.component';
import FaqDropDown from '../components/faq/faq-dropdown.component';

import { Layout, Footer, MetaData, FadeInAnimation } from '../components/shared';

const FAQ = (props) => {
   
    const { data, baseUrlApp } = props;

    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const title = _.get(data, 'acf.main_title');
    const paragraph = _.get(data, 'acf.main_paragraph');
    const sections = _.get(data, 'acf.main_sections');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onWhatsAppClick = () => {
        eventService.logCustomEvent('whatsapp_faq', {
            description: 'Clicked on whatsapp from FAQ page',
        });
    };

    return (
        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} canonical={`${baseUrlApp}/faq`} />

            <div className='container-root container-root-maxWidthLg faq-container' id="container_opacity">

                <FadeInAnimation>

                    <div className='faq-page-header'>

                        <h3 id="faq_header" className='faq-title'>
                            {title}
                        </h3>

                        <p>{paragraph}</p>

                        <h6 className='faq-paragraph'>WhatsApp</h6>

                        <IconButton
                            id="whatsapp-button"
                            href="https://api.whatsapp.com/send?phone=27662818767"
                            target="_blank"
                            rel="noreferrer"
                            onClick={onWhatsAppClick}
                            className='faq-icon-button'
                        >
                            <img
                                src="/assets/images/whatsapp_icon.png"
                                alt="WhatsApp"
                                width={16.5}
                                height={16.5}
                            />
                        </IconButton>

                    </div>

                    <FaqDropDown sections={sections} />

                    <div className='faq-tab-section'>

                        <FaqTabs sections={sections} />

                        <div id='faq-accordion-section'>
                            <FaqAccordion sections={sections} />
                        </div>

                    </div>

                </FadeInAnimation>
                
            </div>

            <Footer />
        
        </Layout>
    );
};

export default FAQ;

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('faq');    
    return {
        props: {
            data: resp
        }
    };
};

FAQ.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};

